import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-primary/10", className)}
      {...props}
    />
  )
}

const PlansSkeletons = () => {
  return (
    <div className="w-full mt-6 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
      <div
        className={"animate-pulse rounded-md bg-primary/10 w-30% h-[600px]"}
      />

      <div
        className={"animate-pulse rounded-md bg-primary/10 w-30% h-[600px]"}
      />

      <div
        className={"animate-pulse rounded-md bg-primary/10 w-30% h-[600px]"}
      />

      <div
        className={"animate-pulse rounded-md bg-primary/10 w-30% h-[600px]"}
      />
    </div>
  )
}

export default PlansSkeletons;